import {Box, Button, Divider} from '@mui/material';
import {Fragment} from 'react';

/**
 * SubNavbar component.
 * See function definition for more details on the array of objects.
 * @param {Object} props - Component props
 * @param {Array.<{
 *    icon: React.Component, // The icon component for the button.
 *    value: string, // The value associated with the option(this will be used in a useState).
 *    text: string // The text displayed on the button(label for the value).
 * }>} props.options - The array of options (see function definition for more details).
 * @param {string} props.selected - The selected option value.
 * @param {function} props.setSelected - The function to set the selected option.
 * @param {boolean} props.disabled - If the component can be interact with
 *
 * @returns {React.Component} The rendered SubNavbar component.
 */
export const SubNavbar = ({options, selected, setSelected, disabled}) => {
  return (
    <Box sx={{display: 'flex', my: 1}}>
      {options.map((option, idx) => {
        return (
          <Fragment key={idx}>
            <Button
              disabled={disabled}
              startIcon={option.icon}
              onClick={() => setSelected(option.value)}
              sx={{
                py: 0.2,
                color: option.value === selected ? '#3DA9F8' : '#D0D0D0',
              }}
            >
              {option.text}
            </Button>
            {idx !== options.length - 1 ? <Divider flexItem orientation="vertical" sx={{mx: 1}} /> : ''}
          </Fragment>
        );
      })}
    </Box>
  );
};
